import { render, staticRenderFns } from "./listmenu.vue?vue&type=template&id=023b22ce&"
import script from "./listmenu.vue?vue&type=script&lang=js&"
export * from "./listmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports